<template>
    <DxLoadPanel :position="position" class="aca-loadpanel"
                 v-model:visible="loadingVisible"
                 :show-indicator="true"
                 :copy-root-classes-to-wrapper="true"
                 :show-pane="true"
                 :shading="true"
                 :width="150"
                 message="Please wait ..."
                 shading-color="rgba(0,0,0,0.4)" />
    <div class="aca">
        <div class="resp-form">
            <div class="aca-header">
                <div class="pq4-logo">
                </div>
                <div class="aca-welcome">
                    Account Activation
                </div>
                <div class="lgi-welcome-text">
                    {{ message }}
                </div>
            </div>
            <div class="field"> 
                <div class="aca-btns">
                    <DxButton class="logBtn"
                              text="Login"
                              @click="gotoLogin" 
                              type="success" />
                </div>
            </div>
        </div>
        <FooterSmall></FooterSmall>
    </div>
</template>
<script>
import { DxButton } from 'devextreme-vue/button';
import DxLoadPanel from 'devextreme-vue/load-panel';
import FooterSmall from './widgets/FooterSmall.vue';
import axios from 'axios'

const baseUri = "WebApi.asmx/api/registrationService";
const activationResultEnum =
{
        Successfull: 0,
        AllreadyActivated: 1,
        Expired: 2,
        Invalid: 3,
        UnkownError: 4,
        Confirmed: 5
}
export default {

        name: 'LoginPage',
        components: {
            DxButton,
            DxLoadPanel,
            FooterSmall,
        },
        data() {
            return {
                loadingVisible: false,
                message: "",
            }
        },
        mounted() {
        },
        created: function () {
            this.activateAccount();
        },
        props: ["rc"],
        computed: {
        },
        methods: {
            gotoLogin() {
                window.location.href = "../Login.aspx"
            },
            activateAccount() {
                axios
                    .get(baseUri + '/ActivateAccount', { params: { rc: this.rc } })
                    .then(res => {
                        if (res.data.success == true) {
                            switch (res.data.status) {
                                case activationResultEnum.Successfull:
                                    this.message = "The account activation was successfull"
                                    break
                                case activationResultEnum.AllreadyActivated:
                                    this.message = "Your account has already been successfully confirmed"
                                    break
                                case activationResultEnum.Expired:
                                    this.message = "The activation link is expired"
                                    break
                                case activationResultEnum.Invalid:
                                    this.message = "The activation link is invalid"
                                    break
                                case activationResultEnum.UnkownError:
                                    this.message = "Unknown error"
                                    break
                                case activationResultEnum.Confirmed:
                                    this.message = "The account activation was successfull"
                                    break

                            }
                        }
                        else {
                            alert("Server Error", "Registration")
                        }
                    })
            },
        },
        watch: {
        },
}
</script>
<style>
    .aca .field {
        display: flex;
        flex-direction: column;
        padding: 10px 0px 10px 0px;
    }

    .aca .aca-err-msg {
        color: red;
        font-size: 12px;
        margin-top: 25px;
    }

    .aca .aca-btns {
        display: flex;
        flex-direction: column;
    }


    .aca .aca-btns {
        text-align: center;
    }

    .aca .dx-pass-value, .aca .dx-email-value {
    }


    .aca-loadpanel .dx-loadpanel-indicator.dx-loadindicator.dx-widget {
        margin: auto;
        display: block;
    }

    .login_aspx #pq4Logo {
        display: none;
    }

    .aca div#summary {
        margin-bottom: 10px;
    }

    .aca-welcome {
        font-size: 17px;
        text-align: center;
        margin: 10px 0px;
        font-weight: 700;
        color: #e97035;
    }

    .aca-welcome-text {
        font-size: 15px;
        text-align: center;
        margin-bottom: 5px;
    }

    .aca-footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .aca-footer-text {
        font-size: 12px;
    }

    .aca .aca-sign-btn {
        color: #f65923;
        font-size: 12px;
        font-weight: bold;
    }
</style>